export default function (template, params) {
  const keys = Object.keys(params);
  let link = template;
  keys.forEach((key) => {
    const pattern = `:${key}`;
    link = link.replace(new RegExp(pattern, 'g'), params[key]);
  });
  return link;
}
